import React from 'react';
import { SendFeedbackContext } from './SendFeedbackContext';

export const useSendFeedback = () => {
  return React.useContext(SendFeedbackContext);
};
